import { useQuery } from "@tanstack/react-query";
import { apiClient } from "@/lib/apiClient";
import { queryKeys } from "@/lib/query";
import type { MerchantActivePool } from "@/types/api/merchant";

export function useMerchantActivePool(merchantId: string | undefined) {
  return useQuery({
    queryKey: queryKeys.merchants.activePool(merchantId ?? ""),
    queryFn: () => apiClient.getData<MerchantActivePool | null>(`/merchants/${merchantId}/pools/current`),
    enabled: !!merchantId,
  });
}
